import { NgModule } from '@angular/core';
import { WishlistStoreModule } from './store/wishlist-store.module';

@NgModule({
  imports: [WishlistStoreModule],
})
export class WishlistDataAccessModule {}
